const getNavigator = () => (typeof navigator !== 'undefined' ? navigator : {});

export const isMobile = () => {
  const nav = getNavigator();
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(nav.userAgent || '') || isIOS();
};

export const isIOS = () => {
  const nav = getNavigator();
  const userAgent = nav.userAgent || '';
  const platform = nav.platform || '';

  return /iPhone|iPad|iPod/i.test(userAgent) ||
    /iPad|iPhone|iPod/i.test(platform) ||
    (platform === 'MacIntel' && Number(nav.maxTouchPoints || 0) > 1);
};

export const isAndroid = () => {
  return /Android/i.test(getNavigator().userAgent || '');
};

export const isStandalonePwa = () => {
  if (typeof window === 'undefined') return false;
  return window.matchMedia?.('(display-mode: standalone)').matches || window.navigator?.standalone === true;
};

export const isIOSNonStandalonePwa = () => {
  return isIOS() && !isStandalonePwa();
};

export const isTesla = () => {
  const nav = getNavigator();
  const userAgent = (nav.userAgent || '').toLowerCase();
  const platform = nav.platform ? nav.platform.toLowerCase() : '';
  
  // Détection spécifique Tesla Browser
  return userAgent.includes('tesla') || 
         userAgent.includes('teslabrowser') ||
         platform.includes('tesla') ||
         // Tesla utilise souvent QtWebEngine
         (userAgent.includes('qtwebengine') && userAgent.includes('linux')) ||
         // Détection par résolution d'écran typique Tesla (17" touchscreen)
         (window.screen && window.screen.width === 1920 && window.screen.height === 1200);
};
